import {z} from 'zod';

import {optionItemSchema} from '../common/OptionItemSchema';

export const extractDeliveryNoteDocumentMessageInputSchema = z
  .object({
    fileId: z.string().optional(),
    zipId: z.string().optional(),
    fileName: z.string(),
    tenantId: z.string(),
    requestId: z.string(),
    suppliers: z.array(optionItemSchema),
    units: z.array(optionItemSchema),
    vat: z.array(optionItemSchema),
  })
  .refine((data) => data.fileId || data.zipId, {
    message: 'Either fileId or zipId must be provided',
  });

export type ExtractDeliveryNoteDocumentMessageInput = z.infer<
  typeof extractDeliveryNoteDocumentMessageInputSchema
>;
